import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { liveOpenings } from '../mock';
import { X, MapPin, IndianRupee, ArrowUpRight, Briefcase } from 'lucide-react';

// Shows one live opening as a bottom-left toast popup.
const JobNotification = () => {
  const [current, setCurrent] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const [seen, setSeen] = useState([]);

  useEffect(() => {
    let mounted = true;
    let timeoutShow;

    const show = () => {
      if (!mounted) return;
      // Pick a random opening we’ve not shown recently
      const pool = liveOpenings.filter((j) => !seen.includes(j.id));
      const src = pool.length ? pool : liveOpenings;
      const job = src[Math.floor(Math.random() * src.length)];
      setSeen((s) => (s.length > liveOpenings.length - 2 ? [job.id] : [...s, job.id]));
      setCurrent(job);
      setDismissed(false);

    };

    // Initial delay before first popup
    timeoutShow = setTimeout(show, 5000);

    return () => {
      mounted = false;
      clearTimeout(timeoutShow);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!current) return null;

  return (
    <div
      className={`fixed left-4 md:left-6 bottom-24 md:bottom-28 z-40 max-w-[320px] w-[calc(100vw-2rem)] transition-all duration-500 ${
        dismissed ? 'opacity-0 translate-y-3 pointer-events-none' : 'opacity-100 translate-y-0'
      }`}
    >
      <div className="relative bg-[#f5f1e6] border border-[#143324]/12 rounded-2xl shadow-lg p-4 pr-8 backdrop-blur-sm">
        <button
          onClick={() => setDismissed(true)}
          aria-label="Close"
          className="absolute top-2 right-2 w-6 h-6 rounded-full text-[#3d3d3d] hover:bg-[#143324]/8 flex items-center justify-center"
        >
          <X size={13} />
        </button>

        <div className="flex items-center gap-2 mb-2">
          <span className="relative flex w-2 h-2">
            <span className="absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-70 pulse-dot" />
            <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500" />
          </span>
          <span className="text-[10.5px] tracking-wider uppercase text-[#143324] font-body font-medium">
            New opening · {current.posted}
          </span>
        </div>

        <p className="font-body font-semibold text-[#143324] text-[14px] leading-snug mb-1">
          {current.role}
        </p>
        <p className="text-[12px] text-[#3d3d3d] font-body mb-3">
          at <span className="text-[#143324]">{current.company}</span>
        </p>

        <div className="flex items-center gap-3 text-[11.5px] text-[#3d3d3d] font-body mb-3">
          <span className="inline-flex items-center gap-1"><MapPin size={11} /> {current.location.split(' ·')[0]}</span>
          <span className="inline-flex items-center gap-1"><Briefcase size={11} /> {current.experience}</span>
          <span className="inline-flex items-center gap-1"><IndianRupee size={11} /> {current.salary}</span>
        </div>

        <Link
          to="/contact"
          className="inline-flex items-center gap-1.5 text-[12px] text-[#143324] font-body hover:gap-2 transition-all"
        >
          View & Apply <ArrowUpRight size={12} />
        </Link>
      </div>
    </div>
  );
};

export default JobNotification;
